import { call, put } from '@redux-saga/core/effects';
import { api, apiErrorHandler, notify } from 'services';
import {
  ListWarehouseBuildingsActions as Actions,
  ListWarehouseBuildingsRequestAction as RequestAction,
} from 'store/ducks/warehouseBuildings';

/**
 * O backend resolve quais prédios o armazém alcança (`warehouse_areas → areas →
 * buildings`). O frontend nunca monta essa regra sozinho, e por isso a rota é
 * específica do armazém em vez de filtrar a listagem global de prédios.
 */
export function* listWarehouseBuildingsRequest(action: any) {
  const { warehouseId, onSuccess, onFailure }: RequestAction = action;

  try {
    const { data } = yield call(api.get, `warehouses/${warehouseId}/buildings`);
    onSuccess && onSuccess();
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage));
  }
}
